"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = Queue;

function Queue() {
  this.__publisherQueue = [];
  this.__consumerQueue = [];
}

_extends(Queue.prototype, {
  push: function push(task) {
    if (this.__consumerQueue.length === 0) {
      this.__publisherQueue.push(task);
    } else {
      this.__consumerQueue.shift()(task);
    }
  },

  pop: function pop() {
    var _this = this;

    if (this.__publisherQueue.length === 0) {
      return new Promise(function (resolve) {
        return _this.__consumerQueue.push(resolve);
      });
    } else {
      return Promise.resolve(this.__publisherQueue.shift());
    }
  },

  size: function size() {
    return this.__publisherQueue.length;
  }
});
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/blocking-queue/lib/queue.js
// module id = 940
// module chunks = 2 6